import React from "react";

export function getData(env,url,params) {
    var data = convertModelToFormData(params);

    fetch(url, {
        method: 'POST',
        body: data,
        mode: 'cors'
    }).then(res => res.json())
        .then(
            (result) => {
                const columnsRaw = result.extraInfo.templateTableHead;
                const dataraw = result.products;
                const columns = columnsRaw.map(item => {
                    return {"Header":item.Attribute.name_ro,"accessor":item.Attribute.attribute_key} });
                const lines = dataraw.map(line => {
                    let data = {};
                    for(const key in line){
                        data[key] = line[key];
                    }
                    return data;
                });
                env.setState({columns:columns,data:lines, pages:Math.ceil(result.filterStatistics.total_items/result.filterStatistics.products_per_page)});
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
               console.log('error');
            }
        );




}

function convertModelToFormData(data = {}, form = null, namespace = '') {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (data.hasOwnProperty(propertyName) && data[propertyName] instanceof File) {
            files[propertyName] = data[propertyName]
        } else {
            model[propertyName] = data[propertyName]
        }
    }

    model = JSON.parse(JSON.stringify(model))
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName)) continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date)
            formData.append(formKey, model[propertyName].toISOString());
        else if (model[propertyName] instanceof File) {
            formData.append(formKey, model[propertyName]);
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === 'object') convertModelToFormData(element, formData, tempFormKey);
                else formData.append(tempFormKey, element.toString());
            });
        }
        else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            convertModelToFormData(model[propertyName], formData, formKey);
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }

    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            formData.append(propertyName, files[propertyName]);
        }
    }
    return formData;
}